import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Badge, Col, Row } from 'reactstrap';
import { withApiService } from '../../api';
import './chats.css';
import { couponStatus, number_format, utcDateFormat } from '../../store/actions/UtilsOperation';
import { getCouponCodes } from '../../store/actions/couponsActions';
import Spinner from '../../components/Spinner';
class ModalDiscount extends Component {

    constructor(props) {
        super(props);
	}   

   	render() {
        const { coupon, currency, json_lang } = this.props; 

        const status = couponStatus(coupon.status);
        
        return (
            <div
                style={{
                    backgroundColor: "#ECE5DD", 
                    margin: "30px",
                    padding: "10%",
                    borderRadius: "20px",
                    boxShadow: "rgb(0 0 0 / 47%) 0px 2px 5px"
            }}>
                <div className='text-center mb-4'>
                    <h2 >Cupón: {coupon.name}</h2>
                    {status &&
                        <span className={status.style}>
                            {status.text}
                        </span>
                    }
                </div>
                <Row>
                    <Col md="6">
                        <div 
                        style={{ 
                            display: "flex",
                            flexDirection: "column",
                            marginLeft: "5px"
                        }}>
                            <label className={`text-muted mb-2 w-100`}>{json_lang.common.details}</label>
                            <span className="mb-2">
                                <b>{coupon.config.is_cashback ? "Cashback" : json_lang.common.discount}: </b>{ coupon.price_e2 > 0 
                                ? `${number_format(coupon.price_e2 / 100)} ${currency} ` 
                                : `${number_format(coupon.price_prc * 100)}%`}
                            </span>
                            {
                               coupon.config.max_discount_e2 > 0 && (
                                    <span className="mb-2">
                                        <b>{ `${json_lang.common.max_discount}:`}</b>
                                        {`${number_format((coupon.config.max_discount_e2/coupon.price_prc)/100)} ${currency}`}
                                    </span>
                               )
                            }
                            {
                               coupon.config.max_discount_e2 > 0 && (
                                    <span className="mb-2">
                                        <b>{ `${json_lang.common.amount_limit}:`}</b>
                                        {`${number_format((coupon.config.max_discount_e2))} ${currency}`}
                                    </span>
                               )
                            }
                            <span className="mb-2">
                                <b>{json_lang.order_details.applies_to}: </b>{json_lang.common[coupon.applies_to]}
                            </span>
                            <span className="mb-2">
                                <b>{json_lang.order_details.type}: </b>{json_lang.common[coupon.type]}
                            </span>
                            <span className="mb-2">
                                <b>{json_lang.common.target}: </b>{json_lang.common[coupon.target_type]}
                            </span>
                            <span className="mb-2">
                                <b>{json_lang.order_details.used}: </b>{coupon.spent_count} / {coupon.total_count === 0 
                                ? <Badge color="light">{json_lang.common.unlimited}</Badge> 
                                : coupon.total_count}
                            </span>
                            
                            <span className="mb-2">
                                <b>{json_lang.common.min_purchase}: </b> {coupon.min_purchase_e2 && coupon.min_purchase_e2 > 0 
                                ? `${number_format(coupon.min_purchase_e2 / 100)} ${currency}` 
                                : json_lang.order_details.not_applicable}
                            </span>
                            { coupon.price_prc > 0 &&
                                <span className="mb-2">
                                    <b>{json_lang.common.max_discount}: </b> {coupon.config.max_discount_e2 && coupon.config.max_discount_e2 > 0 
                                    ? `${number_format((coupon.config.max_discount_e2/coupon.human_price_prc))} ${currency}` 
                                    : json_lang.order_details.not_applicable}
                                </span>
                            }
                            
                            <span className="mb-2">
                                <b>{json_lang.order_details.starts}: </b>{coupon.starts_at 
                                ? utcDateFormat(coupon.starts_at,'YYYY-MM-DD HH:mm') 
                                : json_lang.common.undefined}
                            </span>
                            <span>
                                <b>{json_lang.order_details.ends}: </b>{coupon.ends_at 
                                ? utcDateFormat(coupon.ends_at, 'YYYY-MM-DD HH:mm') 
                                : json_lang.common.undefined}
                            </span>
                        </div>
                    </Col>
                {
					coupon.type === "batch" && <Col md="6">
                        <label className="text-muted text-center w-100">{json_lang.common.used_code}</label>
                        <ul style={{maxHeight: `150px`,overflow: `auto`,minHeight: `20px`}}>
                            <div className="text-center">
                                {
                                coupon.promo_code ?
                                    <li >{coupon.promo_code}</li>
                                :
                                    <li>{`Aún no se han usado ningún código`}</li>
                                }                                                       
                            </div>
                        </ul>
                    </Col>
				}
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        json_lang: state.json_lang,
        couponCodes: state.coupon
    }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCouponCodes: (id) => dispatch(getCouponCodes(id))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withApiService(ModalDiscount));


// WEBPACK FOOTER //
// ./src/views/Orders/ModalDiscount.jsx